import axios from "axios";

export default axios.create({
  // baseURL: "http://localhost:8000/api/v1/",
  // baseURL : 'https://gm-smart-api.gbionik.com/api/v1/'
  baseURL : 'https://beautiful-cerf.212-227-211-20.plesk.page/api/v1/'
});

export const http_client = (token: string) =>
  axios.create({
    // baseURL: "http://localhost:8000/api/v1/",
    // baseURL : 'https://gm-smart-api.gbionik.com/api/v1/',
    baseURL : 'https://beautiful-cerf.212-227-211-20.plesk.page/api/v1/',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

// export const baseURL = `http://localhost:8000`;
// export const baseURL = `https://gm-smart-api.gbionik.com`
export const baseURL = `https://beautiful-cerf.212-227-211-20.plesk.page`
